/* Solena — inclinación 3D automática y suave de la foto del producto (sin interacción) */
(function () {
  var css = '' +
    '.hero__badge{display:none!important}' +
    '.product__gallery{position:static!important;top:auto!important}' +
    '.cl-tilt-wrap{perspective:1400px}' +
    '.cl-tilt{transform-style:preserve-3d;will-change:transform;animation:cl-idle 9s ease-in-out infinite alternate}' +
    '@keyframes cl-idle{0%{transform:rotateX(2deg) rotateY(-6deg)}50%{transform:rotateX(-2deg) rotateY(2deg) translateY(-8px)}100%{transform:rotateX(3deg) rotateY(6deg)}}' +
    '@media (prefers-reduced-motion:reduce){.cl-tilt{animation:none}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  var targets = document.querySelectorAll('.hero__media, .gallery__main');
  Array.prototype.forEach.call(targets, function (el) {
    if (el.parentElement) el.parentElement.classList.add('cl-tilt-wrap');
    el.classList.add('cl-tilt');
  });
})();

/* Solena — navegación premium de la galería (flechas, contador y fundido) */
(function () {
  var css = '' +
    '.gallery__main{isolation:isolate}' +
    '.gallery__slide{display:block!important;position:absolute;inset:0;opacity:0;transform:scale(1.04);transition:opacity .6s ease,transform 1.2s cubic-bezier(.2,.7,.2,1);pointer-events:none}' +
    '.gallery__slide.is-active{opacity:1;transform:scale(1);pointer-events:auto;z-index:1}' +
    '.cl-nav{position:absolute;top:50%;z-index:4;width:52px;height:52px;margin-top:-26px;border-radius:50%;border:1px solid rgba(255,255,255,.7);background:rgba(255,255,255,.55);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);color:#1D2333;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 10px 30px -12px rgba(29,35,51,.45);transition:background .25s,transform .25s,box-shadow .25s}' +
    '.cl-nav:hover{background:#fff;transform:scale(1.08);box-shadow:0 14px 34px -12px rgba(29,35,51,.55)}' +
    '.cl-nav svg{width:20px;height:20px}' +
    '.cl-nav--prev{left:16px}.cl-nav--next{right:16px}' +
    '.cl-count{position:absolute;right:16px;bottom:16px;z-index:4;padding:6px 14px;border-radius:999px;background:rgba(29,35,51,.55);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);color:#fff;font-size:.78rem;letter-spacing:.14em;font-weight:600}' +
    '.cl-dots{display:flex;justify-content:center;gap:8px;margin-top:14px}' +
    '.cl-dot{width:8px;height:8px;border-radius:999px;border:0;padding:0;background:#E4D6D0;cursor:pointer;transition:width .35s ease,background .35s}' +
    '.cl-dot.is-active{width:28px;background:linear-gradient(90deg,#C4655D,#8E3A35)}' +
    '.gallery__thumbs{gap:12px;margin-top:14px}' +
    '.gallery__thumb{flex:0 0 78px;height:78px;border-radius:16px;border:2px solid transparent;opacity:.6;transition:opacity .3s,transform .3s,border-color .3s,box-shadow .3s;box-shadow:0 6px 16px -10px rgba(29,35,51,.4)}' +
    '.gallery__thumb:hover{opacity:1;transform:translateY(-2px)}' +
    '.gallery__thumb.is-active{opacity:1;border-color:#B3504A;box-shadow:0 0 0 3px rgba(179,80,74,.15),0 10px 22px -12px rgba(179,80,74,.6)}' +
    '@media (max-width:749px){.cl-nav{width:42px;height:42px;margin-top:-21px}.cl-nav--prev{left:10px}.cl-nav--next{right:10px}.gallery__thumbs{display:none}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  var arrow = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (d < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>'; };
  Array.prototype.forEach.call(document.querySelectorAll('[data-gallery]'), function (g) {
    var main = g.querySelector('.gallery__main');
    var slides = g.querySelectorAll('[data-slide]');
    if (!main || slides.length < 2) return;
    var thumbs = g.querySelectorAll('[data-thumb]');
    var n = slides.length;
    var count = document.createElement('div'); count.className = 'cl-count'; main.appendChild(count);
    var dots = document.createElement('div'); dots.className = 'cl-dots';
    for (var i = 0; i < n; i++) { var b = document.createElement('button'); b.type = 'button'; b.className = 'cl-dot'; b.setAttribute('aria-label', 'Imagen ' + (i + 1)); b.dataset.i = i; dots.appendChild(b); }
    main.insertAdjacentElement('afterend', dots);
    function current() { for (var i = 0; i < n; i++) if (slides[i].classList.contains('is-active')) return i; return 0; }
    function go(k) {
      k = (k + n) % n;
      for (var i = 0; i < n; i++) slides[i].classList.toggle('is-active', i === k);
      Array.prototype.forEach.call(thumbs, function (t, i) { t.classList.toggle('is-active', i === k); });
      sync();
    }
    function sync() {
      var c = current();
      count.textContent = (c + 1) + ' / ' + n;
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === c); });
    }
    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'cl-nav cl-nav--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Imagen anterior' : 'Imagen siguiente');
      b.innerHTML = arrow(dir === 'prev' ? -1 : 1);
      b.addEventListener('click', function (e) { e.preventDefault(); go(current() + (dir === 'prev' ? -1 : 1)); });
      main.appendChild(b);
    });
    dots.addEventListener('click', function (e) { var d = e.target.closest('.cl-dot'); if (d) go(+d.dataset.i); });
    Array.prototype.forEach.call(thumbs, function (t) { t.addEventListener('click', function () { setTimeout(sync, 0); }); });
    main.addEventListener('touchend', function () { setTimeout(sync, 0); });
    sync();
  });
})();
